import { render, staticRenderFns } from "./ScoreObject.vue?vue&type=template&id=53a5440d&scoped=true&"
import script from "./ScoreObject.vue?vue&type=script&lang=js&"
export * from "./ScoreObject.vue?vue&type=script&lang=js&"
import style0 from "./ScoreObject.vue?vue&type=style&index=0&id=53a5440d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5440d",
  null
  
)

component.options.__file = "ScoreObject.vue"
export default component.exports